import { PeopleTeam24Filled, PeopleTeam24Regular } from "@fluentui/react-icons";

import React from "react";
import { TeamAppConfig } from "Apps/TeamAppModel";

export const TeamsApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "TeamsApp" */ "./TeamsApp");
    return { default: namedExport.TeamsApp };
});

export const Teams: TeamAppConfig = {
    title: "Teams",
    regularIcon: PeopleTeam24Regular,
    filledIcon: PeopleTeam24Filled,
    path: "/Teams",
    description: "Teams app provides teams and oncall schedule information, as well as easily accessible contact info for relevant engineers.",
    team: "OSP",
    publicId: "Exchange\\OSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: ["oncall", "schedule", "substitutions", "rotations"],
    app: TeamsApp
};
